// extracted by mini-css-extract-plugin
module.exports = {"changesButton":"profile-confirmation_changesButton__3h3KR","correctButton":"profile-confirmation_correctButton__2HHVv","buttonGrid":"profile-confirmation_buttonGrid__foXJv"};